import { render, staticRenderFns } from "./PrivateKeysFormGlobal.vue?vue&type=template&id=c9cb8668&"
import script from "./PrivateKeysFormGlobal.vue?vue&type=script&lang=js&"
export * from "./PrivateKeysFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports